import React from 'react'
import { initializeApollo } from '@gql/client'
import { CategorieHelpOnlineDocument, PaginaDocument } from '@gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'
import FaqHubTemplate from '@components/templates/FaqHubTemplate/FaqHubTemplate'

const HelpOnlinePage = ({ pagina, categorieHelpOnline }) => {
  return <FaqHubTemplate pagina={pagina} categorieHelpOnline={categorieHelpOnline} />
}

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ preview, previewData, locale }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'emak-help-online-index', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    const {
      data: { categorieHelpOnline },
    } = await client.query({
      query: CategorieHelpOnlineDocument,
    })

    return {
      props: { pagina, categorieHelpOnline },
      revalidate: 60 * 20,
    }
  },
  'help-online'
)

export default HelpOnlinePage
